import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\AddItemToEnaosController::__invoke
* @see app/Http/Controllers/Item/AddItemToEnaosController.php
* @route '/api/item/{item}/enaos/item-for-sales'
*/
const AddItemToEnaosController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddItemToEnaosController.url(args, options),
    method: 'post',
})

AddItemToEnaosController.definition = {
    methods: ["post"],
    url: '/api/item/{item}/enaos/item-for-sales',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\AddItemToEnaosController::__invoke
* @see app/Http/Controllers/Item/AddItemToEnaosController.php
* @route '/api/item/{item}/enaos/item-for-sales'
*/
AddItemToEnaosController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return AddItemToEnaosController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\AddItemToEnaosController::__invoke
* @see app/Http/Controllers/Item/AddItemToEnaosController.php
* @route '/api/item/{item}/enaos/item-for-sales'
*/
AddItemToEnaosController.post = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddItemToEnaosController.url(args, options),
    method: 'post',
})

export default AddItemToEnaosController